import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Plan {
    _id: string;
    name: string;
    price: number;
    documents: number;
    users: number;
    features: string[];
    isActive: boolean;
    description?: string;
    createdAt?: string;
    updatedAt?: string;
    __v?: number;
}

@Injectable({ providedIn: 'root' })
export class PlanService {
    apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getPlans(): Observable<Plan[]> {
        return this.http.get<Plan[]>(`${this.apiUrl}/plans`);
    }

    getPlanById(id: string): Observable<Plan> {
        return this.http.get<Plan>(`${this.apiUrl}/plans/${id}`);
    }

    createPlan(payload: Partial<Plan>): Observable<Plan> {
        return this.http.post<Plan>(`${this.apiUrl}/plans`, payload);
    }

    updatePlan(id: string, payload: Partial<Plan>): Observable<Plan> {
        return this.http.patch<Plan>(`${this.apiUrl}/plans/${id}`, payload);
    }

    deactivatePlan(id: string): Observable<Plan> {
        return this.http.patch<Plan>(`${this.apiUrl}/plans/${id}/deactivate`, {});
    }
    updateStatus(id: string, isActive): Observable<Plan> {
        return this.http.patch<Plan>(`${this.apiUrl}/plans/${id}/status`, { isActive });
    }
}
